import type { JSX } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

export interface MultiSelectFilterProps {
  id: string;
  label: string;
  value: string[];
  options: string[];
  onChange: (value: string[] | undefined) => void;
}

function toggleOption(selected: string[], option: string): string[] {
  return selected.includes(option)
    ? selected.filter((entry) => entry !== option)
    : [...selected, option];
}

export function MultiSelectFilter({
  id,
  label,
  value,
  options,
  onChange,
}: MultiSelectFilterProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-sm font-medium leading-none">{label}</span>
      <div className="flex flex-wrap items-center gap-3">
        {options.map((option) => (
          <div key={option} className="flex items-center gap-1.5">
            <Checkbox
              id={`${id}-${option}`}
              checked={value.includes(option)}
              onCheckedChange={() => onChange(toggleOption(value, option))}
            />
            <Label htmlFor={`${id}-${option}`} className="font-normal">
              {option}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
}
